import React from "react";
import { Box, Typography } from "@mui/material";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Stack from '../../../assets/stack.png'
const BalanceCard = ({paymentOption}) => {
  //logger.log("balance",paymentOption)
  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: "16px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        display: "flex",
        alignItems: "center",
        gap: 2,
        px: 2.5,
        py: 2,
       
        width:"100%",
      }}
    >
      {/* Left icon circle */}
      <Box
        sx={{
          backgroundColor: "#FBE240",
          borderRadius: "50%",
          width: 56,
          height: 56,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
       <img src={Stack} style={{width:"25px"}}/>
      </Box>

      {/* Right content */}
      <Box sx={{ flex: 1 }}>
        <Typography
          variant="h5"
          sx={{ color: "#0C9B37", fontWeight: 700, lineHeight: 1.2,textAlign:"start" }}
        >
         ₹{' '}{paymentOption && Number(paymentOption[3].balance).toFixed(2)}

        </Typography>
        <Typography
          variant="subtitle1"
          sx={{ color: "#4B2E1E", fontWeight: 600, lineHeight: 1.2 ,textAlign:"start" }}
        >
          Available Balance
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", mt: 0.5 ,textAlign:"start" }}>
          <InfoOutlinedIcon
            sx={{ fontSize: 14, color: "#7B7B7B", mr: 0.5 }}
          />
          <Typography
            variant="caption"
            sx={{
              color: "#7B7B7B",
              fontStyle: "italic",
              fontWeight: 400,
            }}
          >
            Cashback can only be used for app orders
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default BalanceCard;
